import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

// Keep one package tree across breakpoints: switching wrappers would remount connected cards.
const Options = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min(var(--package-selection-mobile-card-width, ${rem(288)}), 100%);
  gap: ${rem(20)};
  padding: ${rem(4)} ${rem(16)} ${rem(16)};
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: ${rem(16)};

  > * {
    min-width: 0;
    scroll-snap-align: start;
  }

  > :only-child {
    width: 100%;
  }

  &:has(> :only-child) {
    grid-auto-columns: 100%;
  }

  ${mediaQueryUp.tablet} {
    grid-auto-columns: min(${rem(368)}, 100%);
  }

  ${mediaQueryUp.desktop} {
    grid-auto-flow: row;
    grid-auto-columns: auto;
    gap: ${rem(8)};
    background-color: var(--palette-neutral-surface-light-background, ${props => props.theme.palette.neutral.surface.lightBackground});
    padding: 0;
    overflow: visible;
    scroll-snap-type: none;

    > :first-child { border-top: 0; }
    &:last-child > :last-child { border-bottom: 0; }
  }
`

function AccommodationPackageSelectionOptions({ children, id }: PropsWithChildren<{ id?: string }>) {
  return <Options id={id}>{children}</Options>
}

export default AccommodationPackageSelectionOptions
